import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_ENDPOINT } from "../utils/constants";
import { getDbHeader, toastError } from "../utils/util";
import MuPb from "../widgets/MuPb";
import { EbadgeService } from "./EbadgeService";
const ServiceWelcomeMessage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [exhibitor, setExhibitor] = useState();

  useEffect(() => {
    document.title = "SERVICE BADGE";
  }, []);

  useEffect(() => {
    loadUser();
  }, []);
  async function loadUser() {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_ENDPOINT}/onsite/get-service-badge-mobile?id=${id}`,
        getDbHeader()
      );
      if (response.status === 200) {
        setExhibitor(response.data);
      } else if (response.status === 204) {
        // Handle successful response with no content
        toast.info("No Exhibitor Found with Mobile number.");
      }
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <MuPb />;
  }

  return (
    <Box mt={2} width={"100%"} maxWidth={500} ml={"auto"} mr={"auto"}>
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}
      >
        THANK YOU FOR REGISTERING. PLEASE SHOW THIS BADGE AT THE SECURITY TO
        ENTER.
      </Typography>
      {exhibitor && <EbadgeService user={exhibitor} isPreview={true} />}
    </Box>
  );
};

export default ServiceWelcomeMessage;
